import { useQuery } from "@tanstack/react-query";
import { Kart, Rozet } from "@koclukpanel/ui";
import { ApiHatasi } from "../api";
import { ogrenciSiparisleri } from "../api-magaza";
import { PANEL_IPTAL_NEDENI_ETIKETI, SIPARIS_DURUMU_TONU } from "../magaza-etiketleri";
import { SIPARIS_DURUMU_ETIKETI } from "../magaza-tipleri";

/**
 * SİPARİŞ KARTI — F-GAM-17 (oyunlaştırma dalga 2 / 7a). Öğrenci 360° genel bakışta, `oyun.siparis.goruntule` izniyle.
 *
 * Koç atanmış öğrencisinin siparişlerini SALT OKUR görür: ürün, durum, tarih. ADRES YOK (sunucu da döndürmez) ve
 * düğme yok; durum, kargo ve iptal işleri yalnız yönetimde. Modül kapalı ya da kayıt yoksa (404 / boş liste) kart
 * HİÇ çizilmez: boş bir "sipariş yok" kutusu koçun işine yaramaz.
 */
export function SiparisKarti({ ogrenciId }: { ogrenciId: string }) {
  const q = useQuery({
    queryKey: ["ogrenci-siparisleri", ogrenciId],
    queryFn: () => ogrenciSiparisleri(ogrenciId),
    retry: false,
  });

  if (q.isPending) return null;
  if (q.error && q.error instanceof ApiHatasi && q.error.durum === 404) return null;
  if (q.error)
    return (
      <Kart baslik="Mağaza siparişleri">
        <p role="alert" className="text-hata-700 text-sm">
          Siparişler alınamadı.
        </p>
      </Kart>
    );
  if (q.data.length === 0) return null;

  return (
    <Kart
      baslik="Mağaza siparişleri"
      aciklama="Öğrencinin puanla verdiği siparişler (salt okunur)."
    >
      <ul className="divide-notr-100 divide-y text-sm">
        {q.data.map((s) => (
          <li key={s.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
            <div className="flex flex-col gap-0.5">
              <p className="text-notr-900">{s.urunAdi}</p>
              <p className="text-notr-600 text-xs">
                {s.tarih.slice(0, 10)}
                {s.iptalNedeni ? ` · ${PANEL_IPTAL_NEDENI_ETIKETI[s.iptalNedeni]}` : ""}
              </p>
            </div>
            <Rozet ton={SIPARIS_DURUMU_TONU[s.durum]}>{SIPARIS_DURUMU_ETIKETI[s.durum]}</Rozet>
          </li>
        ))}
      </ul>
    </Kart>
  );
}
